<router-outlet />

@for (toast of toasts(); track toast.id) {
  <app-toast
    [toast]="toast"
    (dismissed)="onToastDismissed($event)"
    (actionClicked)="onToastActionClicked($event)"
  />
}
